import { EndProductEmittingMethodInput } from '@/api/EmissionReportModel'
import useI18n from '@/shared/hooks/useI18n'
import { Table } from '@/common'
import { TableRow } from '@/common'
import { TableColumnHeader } from '@/common'
import InputMaterialsTableRow from './InputMaterialsTableRow'
import { PreconsumerScrapMaterial, scrapMaterialName } from '@/api/PreconsumerScrapMaterialModel'

export default function InputMaterialsTable({
  endProductEmittingMethodInputs,
  isViewMode,
  preconsumerScrapMaterials,
  onRemove,
  onEdit
}: {
  endProductEmittingMethodInputs: EndProductEmittingMethodInput[]
  onRemove: (id: string | number, isScrap: boolean) => void
  isViewMode: boolean
  preconsumerScrapMaterials: PreconsumerScrapMaterial[]
  onEdit: (id: string | number, isScrap: boolean) => void
}) {
  const { t } = useI18n()

  const allItems = [
    ...preconsumerScrapMaterials.map(preconsumerScrapMaterial => ({
      materialName: scrapMaterialName,
      quantityInTonnes: preconsumerScrapMaterial.quantityInTonnes,
      proofFilePath: preconsumerScrapMaterial.proofFilePath,
      id: preconsumerScrapMaterial.id,
      internalId: preconsumerScrapMaterial.internalId,
      details: preconsumerScrapMaterial.details
    })),
    ...endProductEmittingMethodInputs.map(endProductEmittingMethodInput => ({
      materialName: endProductEmittingMethodInput.materialName,
      quantityInTonnes: endProductEmittingMethodInput.quantityInTonnes,
      proofFilePath: endProductEmittingMethodInput.proofFilePath,
      id: endProductEmittingMethodInput.id,
      internalId: endProductEmittingMethodInput.internalId,
      details: null
    }))
  ]

  return (
    <div className="overflow-x-auto w-full">
      <Table className="text-sm">
        <thead>
          <TableRow>
            <TableColumnHeader className="w-56">
              {t('report:materials.table.headers.material')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:materials.table.headers.typeOfScrap')}
            </TableColumnHeader>
            <TableColumnHeader className="w-32">
              {t('report:materials.table.headers.internalId')}
            </TableColumnHeader>
            <TableColumnHeader className="w-64">
              {t('report:materials.table.headers.evidence')}
            </TableColumnHeader>
            <TableColumnHeader className="w-24">
              {t('report:materials.table.headers.quantity')}
            </TableColumnHeader>
            {!isViewMode && <TableColumnHeader className="w-32" />}
          </TableRow>
        </thead>
        <tbody>
          {allItems.map(item => (
            <InputMaterialsTableRow
              key={item.id}
              material={item}
              isViewMode={isViewMode}
              onRemove={onRemove}
              onEdit={onEdit}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}
